import React, { useState, useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import './styles/PlaySettingScreen.css';

const PlaySettingScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [speechRate, setSpeechRate] = useState(0.5);
  const [disableSpeech, setDisableSpeech] = useState(false);
  const [totalQuestions, setTotalQuestions] = useState(50);
  const [nextQuestionDelay, setNextQuestionDelay] = useState(5);
  const [answerDelay, setAnswerDelay] = useState(3);

  const categories = [
    { id: 'A1', label: 'Finnish A1' },
    { id: 'A2', label: 'Finnish A2' },
    { id: 'B1', label: 'Finnish B1' },
    { id: 'B2', label: 'Finnish B2' },
    { id: 'extras', label: t('extraVocabulary') },
  ];

  const [selectedCategories, setSelectedCategories] = useState(
    categories.map((item) => item.id)
  );

  useEffect(() => {}, []);

  const toggleCategory = (categoryId) => {
    if (selectedCategories.length === 1 && selectedCategories.includes(categoryId)) {
      return;
    }
    setSelectedCategories((prevSelected) => {
      if (prevSelected.includes(categoryId)) {
        return prevSelected.filter((id) => id !== categoryId);
      } else {
        return [...prevSelected, categoryId];
      }
    });
  };

  const startQuiz = () => {
    navigate('/play-vocabulary-screen', {
      state: {
        speechRate,
        disableSpeech,
        totalQuestions,
        selectedCategories,
        nextQuestionDelay: nextQuestionDelay * 1000,
        answerDelay: answerDelay * 1000,
      },
    });
  };

  const renderCategoryItem = ({ item }) => (
    <button
      className="categoryItem"
      onClick={() => toggleCategory(item.id)}
      aria-pressed={selectedCategories.includes(item.id)}
    >
      <div className="categoryContent">
        <span className="categoryText">{item.label}</span>
        <div className="checkbox">
          {selectedCategories.includes(item.id) ? <span>&#10003;</span> : null}
        </div>
      </div>
    </button>
  );

  return (
    <div className="container">
      <BackButton to="/vocabulary" label={t('vocabulary')} />
      <h2 className="page-title">{t('playVocabularySettings')}</h2>

      <div className="categoryContainer">
        <div className="setting">
          <div className="sliderContainer">
            <span>{t('totalQuestions')}: {totalQuestions.toFixed(0)}</span>
            <Slider value={totalQuestions} onChange={(value) => setTotalQuestions(value)} min={1} max={500} step={1} />
          </div>
        </div>

        <div className="setting">
          <div className="sliderContainer">
            <span>{t('nextQuestionDelaySec')}: {nextQuestionDelay}</span>
            <Slider value={nextQuestionDelay} onChange={(value) => setNextQuestionDelay(value)} min={1} max={30} step={1} />
          </div>
        </div>

        <div className="setting">
          <div className="sliderContainer">
            <span>{t('answerDelaySec')}: {answerDelay}</span>
            <Slider value={answerDelay} onChange={(value) => setAnswerDelay(value)} min={1} max={30} step={1} />
          </div>
        </div>

        <div className="setting">
          <div className="sliderContainer">
            <span>{t('speechRate')}: {speechRate.toFixed(1)}</span>
            <Slider value={speechRate} onChange={(value) => setSpeechRate(value)} min={0.1} max={2.0} step={0.1} />
          </div>
        </div>

        {categories.map((item) => (
          <React.Fragment key={item.id}>{renderCategoryItem({ item })}</React.Fragment>
        ))}
        <button className="startButton" onClick={startQuiz}>
          <span className="startButtonText">{t('start')}</span>
        </button>
      </div>
    </div>
  );
};

export default PlaySettingScreen;
